import { AnalyticsEventFactory } from '@salsita-ai/platform-project-sdk/domain'
import { initializeAnalyticsService } from '@salsita-ai/platform-project-sdk/react'

export const analyticsService = initializeAnalyticsService({
  gtmId: phoenix.runtimeConfig.GTM_ID,
  debug: phoenix.runtimeConfig.GTM_DEBUG,
  configuratorName: 'metalworks',
})

// FEATURES

const FeatureRemoved = (data: { id: string }) => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'sidebar',
    element: 'featureRemoveButton',
    action: 'click',
    result: 'User removed feature.',
    data,
  })
}

const FeatureAnchorPointsToggled = (value: boolean) => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'sidebar',
    element: 'featureAnchorPointsToggle',
    action: 'click',
    result: 'User toggled feature anchor points.',
    data: value,
  })
}

const FeatureMeasurementToolToggled = (value: boolean) => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'sidebar',
    element: 'featureMeasurementToolToggle',
    action: 'click',
    result: 'User toggled feature measurement tool.',
    data: value,
  })
}

// Navigation

const ProceedToQuoteButtonClicked = (quoteType: string) => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'finalizePage',
    element: 'proceedToQuoteButton',
    action: 'click',
    result: 'User clicked proceed to quote button.',
    data: quoteType,
  })
}

const SummaryButtonClicked = () => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'sidebar',
    element: 'summaryButton',
    action: 'click',
    result: 'User clicked go to summary button.',
  })
}

const BackToSummaryButtonClicked = () => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'finalizePage',
    element: 'backToSummaryButton',
    action: 'click',
    result: 'User clicked back to summary button.',
  })
}

const ReturnToDavewebButtonClicked = () => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'finalizePage',
    element: 'returnToDavewebButton',
    action: 'click',
    result: 'User clicked return to daveweb button.',
  })
}

const CloneConfigurationButtonClicked = () => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'finalizePage',
    element: 'cloneConfigurationButton',
    action: 'click',
    result: 'User clicked clone configuration button.',
  })
}

const CreateNewConfigurationButtonClicked = () => {
  return AnalyticsEventFactory.UserActionEvent({
    section: 'finalizePage',
    element: 'createNewConfigurationButton',
    action: 'click',
    result: 'User clicked create new configuration button.',
  })
}

export const MetalworksAnalytics = {
  BackToSummaryButtonClicked,
  CloneConfigurationButtonClicked,
  CreateNewConfigurationButtonClicked,
  FeatureAnchorPointsToggled,
  FeatureMeasurementToolToggled,
  FeatureRemoved,
  ProceedToQuoteButtonClicked,
  ReturnToDavewebButtonClicked,
  SummaryButtonClicked,
}
